import { Form, Input, TabsProps } from "antd";
import { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import TabLabelField from "components/fields/TabLabelField";
import {
  namePathEqualsMatcher,
  namePathStartsWithMatcher,
} from "utils/formUtils";

import TicketPoolListField from "../TicketPoolListField";

import { TICKET_TEMPLATE_TAB_NAMES } from "./consts";

export const useTicketTemplateFormTabs = () =>
  useMemo<TabsProps["items"]>(
    () => [
      {
        key: TICKET_TEMPLATE_TAB_NAMES.info,
        forceRender: true,
        label: (
          <TabLabelField matcher={namePathEqualsMatcher(["input", "name"])}>
            <FormattedMessage defaultMessage="Template Info" />
          </TabLabelField>
        ),
        children: (
          <Form.Item
            label={<FormattedMessage defaultMessage="Template Name" />}
            name={["input", "name"]}
            required
          >
            <Input />
          </Form.Item>
        ),
      },
      {
        key: TICKET_TEMPLATE_TAB_NAMES.tickets,
        forceRender: true,
        label: (
          <TabLabelField
            matcher={namePathStartsWithMatcher(["input", "ticketPools"])}
          >
            <FormattedMessage defaultMessage="Tickets" />
          </TabLabelField>
        ),
        children: (
          <Form.Item name={["input", "ticketPools"]} noStyle>
            <TicketPoolListField name={["input", "ticketPools"]} />
          </Form.Item>
        ),
      },
    ],
    []
  );
